import * as React from 'react'

import Grid from '@material-ui/core/Grid'
import Grow from '@material-ui/core/Grow'

import { Company }                   from '../../api'
import { Communication }             from '../../redux/ducks'
import { isPresentInAnyOf, memoize } from '../../utils'
import loadable                      from '../hocs/loadable'
import CompanyCard                   from './CompanyCard'

interface CompanyListProps {
  companies: Company []
  editCommunication: Communication
  onEditClick: (companyId: number) => void
  filterValue: string
}

const initState = {
  expandedElementIndex: undefined,
}

class CompanyList extends React.Component<CompanyListProps, typeof initState> {
  public state = initState

  private memoizedEditClick = memoize(
    (id: number) => {
      return () => {
        this.props.onEditClick(id)
      }
    }
  )

  private memoizedExpandClick = memoize(
    (index: number) => {
      return () => {
        this.setExpandedElement(index)
      }
    }
  )

  public render () {
    const { companies } = this.props

    return (
      <Grid
        container
        spacing={8}
        alignItems={'stretch'}
      >
        {companies.map(this.generateCompanyListItem)}
      </Grid>
    )
  }

  private generateCompanyListItem = (company, i) => {
    const { filterValue } = this.props
    const { expandedElementIndex } = this.state
    const { name, contactName } = company

    const shouldDisplay =
      isPresentInAnyOf(
        filterValue,
        [
          name,
          contactName,
        ]
      )

    return (
      (
        <Grow
          key={company.id}
          in={shouldDisplay}
          unmountOnExit
          mountOnEnter
        >
          <Grid item xs={12} md={6}>
            <CompanyCard
              company={company}
              expanded={expandedElementIndex === i}
              onExpandClick={this.memoizedExpandClick(i)}
              onEditClick={this.memoizedEditClick(company.id)}
            />
          </Grid>
        </Grow>
      )
    )
  }

  private setExpandedElement = i => {
    this.setState(state => {
      const expandedElementIndex =
        state.expandedElementIndex === i
          ? undefined
          : i

      return {
        expandedElementIndex,
      }
    })
  }
}

export default loadable(CompanyList)



// WEBPACK FOOTER //
// ./src/components/molecules/CompanyList.tsx